import { theme } from '@theme';
import styled from 'styled-components';

export const ModalBody = styled.div.attrs({
  className: 'modal-body user-profile-modal-dialog',
})`
  padding: 20px;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
`;
type RowDividerProps = {
  borderColor: string;
  padding?: number;
};
export const RowDivider = styled.div.attrs<RowDividerProps>({
  className: 'row divider',
})<RowDividerProps>`
  border-bottom: 1px solid ${(props) => props.borderColor};
  padding-right: ${(props) => props.padding}px;
  padding-left: ${(props) => props.padding}px;
  .text-wrapper {
    min-width: 66.66%;
    float: left;
  }
  .button-wrapper {
    min-width: 33.33%;
    float: left;
  }
`;

type RowDividerChangePasswordProps = {
  borderColor: string;
};
export const RowDividerChangePassword = styled.div.attrs({
  className: 'row divider change-password-section',
})<RowDividerChangePasswordProps>`
  border-bottom: 1px solid ${(props) => props.borderColor};
  .change-password {
    font-size: ${theme.typography.fontSize16}px;
    font-weight: ${theme.typography.fontWeights.semibold};
  }
`;

type IconProps = {
  type: string;
};

export const IconPrimaryUser = styled.i.attrs<IconProps>((props) => ({
  className: `am-icon am-icon-${props.type}`,
}))<IconProps>`
  cursor: pointer;
`;

export const IconDealerUser = styled.i.attrs<IconProps>((props) => ({
  className: `am-icon am-icon-${props.type}`,
}))<IconProps>`
  cursor: pointer;
`;

export const ModalFooter = styled.div.attrs({
  className: 'row',
})`
  padding: 20px;
`;

type ColumnWrapperProps = {
  width?: string;
  textAlign?: string;
};

export const ColumnWrapper = styled.div<ColumnWrapperProps>`
  width: ${(props) => props.width}%;
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  text-align: ${(props) => props.textAlign};
  float: left;
`;

type ButtonWrapperProps = {
  isDisable: boolean;
  width?: string;
  height?: string;
  paddingTopBottom?: string;
  paddingRightLeft?: string;
  color?: string;
  marginBottom?: string;
  marginTop?: string;
};

export const ButtonWrapper = styled.button<ButtonWrapperProps>`
  text-transform: uppercase;
  background-color: ${(props) => (props.isDisable ? theme.palette.disabledGrey : theme.palette.text.purple)} ;
  color:${(props) => (props.color ? props.color : theme.palette.white)};
  border: 1px solid ${(props) => (props.isDisable ? theme.palette.disabledGrey : theme.palette.text.purple)};
  border-radius: 3px;
  font-weight: ${theme.typography.fontWeights.semibold};
  font-size: ${theme.typography.fontSize14}px;
  display: inline-block;
  margin-bottom:${(props) => (props.marginBottom ? props.marginBottom : '0')}px;
  margin-top:${(props) => (props.marginTop ? props.marginTop : '0')}px;
  text-align: center;
  vertical-align: middle;
  cursor: ${(props) => (props.isDisable ? 'default' : 'pointer')};
  padding: ${(props) => props.paddingTopBottom}px ${(props) => props.paddingRightLeft}px;
  line-height: 1.42857143;
  width: ${(props) => props.width};
  height :${(props) => props.height};
}
`;
